export default {
  "booking.verifyTitle": "Confirma tu correo para poder reservar",
  "booking.verifyDesc": "Te enviamos un enlace de verificación cuando creaste tu cuenta. Ábrelo y vuelve a esta página.",
  "booking.verifyResend": "Reenviar enlace",
  "booking.verifySending": "Enviando…",
  "booking.verifySent": "Listo, revisa tu correo (y la carpeta de spam).",
  "booking.verifyResendError": "No pudimos reenviar el enlace. Inténtalo más tarde.",
  "booking.title": "Reserva tu experiencia",
  "booking.subtitle": "Completa tu reserva en 3 simples pasos",
  "booking.step1": "Detalles",
  "booking.step2": "Pago",
  "booking.step3": "Confirmación",
  "booking.tourSummary": "Resumen del tour",
  "booking.date": "Fecha",
  "booking.time": "Hora",
  "booking.guests": "Viajeros",
  "booking.adults": "Adultos",
  "booking.children": "Niños",
  "booking.contactInfo": "Información de contacto",
  "booking.firstName": "Nombre",
  "booking.lastName": "Apellido",
  "booking.email": "Correo electrónico",
  "booking.phone": "Teléfono",
  "booking.specialRequests": "Solicitudes especiales",
  "booking.specialRequestsPlaceholder": "¿Alguna alergia, restricción dietética o petición especial?",
  "booking.priceSummary": "Resumen de precios",
  "booking.adultsTotal": "Adultos",
  "booking.childrenTotal": "Niños",
  "booking.subtotal": "Subtotal",
  "booking.taxes": "Impuestos (16% IVA)",
  "booking.total": "Total",
  "booking.mpTitle": "Pago con Mercado Pago",
  "booking.mpDesc": "Serás redirigido a Mercado Pago para completar tu pago de forma segura",
  "booking.mpAccepted": "Aceptamos",
  "booking.mpCard": "Tarjeta de crédito o débito",
  "booking.mpOxxo": "OXXO",
  "booking.mpSpei": "SPEI / Transferencia",
  "booking.mpSecure": "Pago procesado de forma segura por Mercado Pago",
  "booking.mpPayButton": "Pagar con Mercado Pago",
  "booking.payWith": "Pagar con",
  "booking.cardNumber": "Número de tarjeta",
  "booking.cardHolder": "Titular de la tarjeta",
  "booking.expiry": "Vencimiento",
  "booking.cvv": "CVV",
  "booking.termsNote": "Al completar la reserva aceptas nuestros",
  "booking.termsLink": "términos y condiciones",
  "booking.back": "Anterior",
  "booking.continue": "Continuar",
  "booking.confirm": "Confirmar reserva",
  "booking.processing": "Procesando...",
  "booking.confirmedTitle": "¡Reserva confirmada!",
  "booking.confirmedDesc": "Hemos enviado los detalles a tu correo electrónico",
  "booking.bookingId": "ID de reserva",
  "booking.download": "Descargar confirmación",
  "booking.totalPaid": "Total pagado",
  "booking.paymentId": "ID de pago",
  "booking.merchantOrderId": "ID de orden Mercado Pago",
  "booking.verifyingTitle": "Verificando pago...",
  "booking.verifyingDesc": "Espera un momento mientras confirmamos tu pago con Mercado Pago",
  "booking.successTitle": "¡Pago confirmado!",
  "booking.successDesc": "Tu reserva está confirmada. Enviamos los detalles a tu correo.",
  "booking.pendingTitle": "Pago pendiente",
  "booking.pendingDesc": "Estamos esperando la confirmación del pago. Esto puede tardar unos minutos para métodos como OXXO o SPEI.",
  "booking.rejectedTitle": "Pago no completado",
  "booking.rejectedDesc": "El pago fue rechazado o cancelado.",
  "booking.rejectedHelp": "Puedes intentar de nuevo con otro método de pago.",
  "booking.tryAgain": "Intentar de nuevo",
  "booking.backToHome": "Volver al inicio",
  "booking.viewBookings": "Ver mis reservas",
  "booking.cancel": "Cancelar reserva",
  "booking.notFound": "Tour no encontrado",
  "booking.backToTours": "Volver a tours",
  "booking.loadError": "No pudimos cargar el tour. Intenta de nuevo.",
  "booking.createError": "No pudimos crear la reserva. Intenta de nuevo.",
  "booking.required": "Campo requerido",
  "booking.invalidEmail": "Correo inválido",
  "booking.invalidPhone": "Teléfono inválido",
  "booking.securePayment": "Pago seguro con encriptación SSL",
  "booking.instantConfirm": "Confirmación inmediata",
  "booking.freeCancel": "Cancelación gratuita hasta 24h antes",
  "booking.perPerson": "por persona",
  "booking.perChild": "por niño",
  "booking.totalGuests": "Total de viajeros",
  "booking.guest": "viajero",
  "booking.guestsPlural": "viajeros",
  "booking.paymentTitle": "Pago",
  "booking.paymentSubtitle": "Completa tu pago de forma segura",
  "booking.processingTitle": "Procesando pago",
  "booking.processingDesc": "Estamos conectando con Mercado Pago...",
  "booking.secureConnection": "Conexión segura",
  "booking.confirmTitle": "¡Reserva confirmada!",
  "booking.confirmDesc": "Tu reserva ha sido confirmada exitosamente",
  "booking.orderDetails": "Detalles del pedido",
  "booking.viewVoucher": "Ver voucher",
  "booking.myBookings": "Mis reservas",
  "booking.failedTitle": "Pago fallido",
  "booking.failedDesc": "No pudimos procesar tu pago. Inténtalo de nuevo.",
  "booking.whatHappened": "¿Qué pasó?",
  "booking.failReason1": "La tarjeta fue rechazada por el banco",
  "booking.failReason2": "Fondos insuficientes",
  "booking.failReason3": "Datos de pago incorrectos",
  "booking.voucherTitle": "Voucher de reserva",
  "booking.downloadPdf": "Descargar PDF",
  "booking.voucherPaid": "Pagado",
  "booking.providerContact": "Contacto del proveedor",
  "booking.showQr": "Muestra este código QR al iniciar el tour",

  // Availability picker
  "booking.weekdays": ["L", "M", "X", "J", "V", "S", "D"],
  "booking.spotsTitle_one": "{{count}} lugar",
  "booking.spotsTitle_other": "{{count}} lugares",
  "booking.spotsAvailable_one": "{{count}} lugar disponible",
  "booking.spotsAvailable_other": "{{count}} lugares disponibles",
  "booking.availabilityHelp_one": "Solo los días con cupo suficiente para {{count}} huésped son seleccionables.",
  "booking.availabilityHelp_other": "Solo los días con cupo suficiente para {{count}} huéspedes son seleccionables.",
  "booking.maxGuests": "Máximo {{count}}",

  // Coupons
  "booking.couponLabel": "Código de descuento",
  "booking.couponPlaceholder": "Ej. BAJA10",
  "booking.couponApply": "Aplicar",
  "booking.couponRemove": "Quitar",
  "booking.couponApplied": "Cupón aplicado",
  "booking.couponInvalid": "Cupón no válido.",
  "booking.couponError": "No pudimos validar el cupón.",
  "booking.discount": "Descuento",
  "booking.couponReason.NOT_FOUND": "Este cupón no existe.",
  "booking.couponReason.INACTIVE": "Este cupón ya no está activo.",
  "booking.couponReason.OUTSIDE_WINDOW": "Este cupón no es válido en esta fecha.",
  "booking.couponReason.REDEMPTIONS_EXHAUSTED": "Este cupón ya alcanzó su límite de usos.",
  "booking.couponReason.INVALID": "Cupón no válido.",

  // Voucher
  "booking.voucherNotFound": "No encontramos el voucher de esta reserva.",
  "booking.backToBookings": "Volver a mis reservas",
  "booking.voucherCancelled": "Cancelada",
  "booking.voucherPending": "Pendiente",
  "booking.paymentMethod": "Método de pago",
};